import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useState } from "react";
import Overlay from "../../../../../components/SVGComponents/Tools/Overlay";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import themeContext from "../../../../../context/theme/ThemeContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import { toolTipStyles } from "../../../styles/styles";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const ShowOverlay = () => {
  const { theme } = useContext(themeContext);
  const { username } = useContext(userContext);
  const { showOverlay, setShowOverlay } = useContext(ViewportContext);
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };
  return (
    <>
      <CustomToolTipHost
        delay={TooltipDelay.zero}
        id="layout-selector"
        directionalHint={DirectionalHint.bottomCenter}
        content={
          isMobile
            ? ""
            : showOverlay
            ? t("viewer.tools.hide-overlay")
            : t("viewer.tools.show-overlay")
        }
        styles={toolTipStyles}
      >
        <div
          className={isMobile ? "highlight-tool-mobile" : "highlight-tool"}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            setShowOverlay(!showOverlay);
            logAmplitudeEventWithUsernameAndRole(
              "EVENT_BASIC_OVERLAY_TOOL_USED",
              {},
              username
            );
          }}
          style={{
            height: isMobile ? "50px" : "30px",
            flexDirection: isMobile ? "column" : "row",
          }}
          aria-describedby="layout-selector"
        >
          <Overlay
            color={
              showOverlay
                ? theme.palette.activeTool
                : theme.palette.inactiveTool
            }
          />
          {isMobile && (
            <span
              style={{
                fontSize: "9px",
                lineHeight: "100%",
                fontWeight: "400",
                //color: "#FFFFFF",
                //color: "var(--navbar-header-popup-color-txt)",
                color: "var(--mobile-color-txt)",
                marginTop: "5px",
              }}
            >
              {t("viewer.overlay.overlay")}
            </span>
          )}
        </div>
      </CustomToolTipHost>
    </>
  );
};

export default ShowOverlay;
